import { Select as GrommetSelect, SelectProps } from "grommet";
import styled from "styled-components";

type CustomSelectProps = SelectProps;

export const Select = styled(GrommetSelect)<CustomSelectProps>``;
